import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { H3 } from '../../components';
import { TranslatedCopy } from '../../intl/TranslatedCopy';

export const TermsConditionsBlock = ({ headerId, bodyId, small, bare }) => (
  <div
    className={classnames('border-top-medium-grey pt5-sm pb5-sm u-full-width', {
      [`termsConditions__main_block${small ? 'Small' : ''}`]: !bare
    })}
  >
    <H3>
      <TranslatedCopy id={headerId} />
    </H3>
    <p className='body-4 text-color-secondary mt3-sm'>
      <TranslatedCopy id={bodyId} />
    </p>
  </div>
);

TermsConditionsBlock.propTypes = {
  headerId: PropTypes.string.isRequired,
  bodyId: PropTypes.string.isRequired,
  small: PropTypes.bool,
  bare: PropTypes.bool
};

TermsConditionsBlock.defaultProps = {
  small: false,
  bare: false
};

export default TermsConditionsBlock;
